import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor(private route: Router) {}

  exportToExcel(idTable: string): void {
    // Crear una hoja de trabajo (worksheet)
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(idTable)
    );

    // Crear un libro de trabajo (workbook) y agregar la hoja
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Datos');

    // Generar el archivo Excel y guardarlo
    const excelBuffer: any = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/octet-stream',
    });
    saveAs(data, 'tabla_dinamica.xlsx');
  }

  navigateWithState(url: string, state?: any) {
  this.route.navigate([url], { state });
}

  link(url: string, param?: string) {
    if (param) {
      this.route.navigate([url, param]);
    } else {
      this.route.navigate([url]);
    }
  }

  linkTargetBlank(url: string) {
    window.open(environment.URL_BASE + url, '_blank');
  }

  linkTargetBlankExterno(url: string) {
    window.open(url, '_blank');
  }

  linkParams(url: string, params?: string[]) {
    if (params) {
      this.route.navigate([url, params.join(',')]);
    } else {
      this.route.navigate([url]);
    }
  }

  removeLocalStorage(item: any): void {
    localStorage.removeItem(item);
  }

  setLocalStorage(item: any, value: any): void {
    localStorage.setItem(item, value);
  }

  getLocalStorage(item: any): any {
    return localStorage.getItem(item);
  }

  getJsonLocalStorage(item: any) {
    return JSON.parse(this.getLocalStorage(item));
  }

  removeSessionStorage(item: any): void {
    sessionStorage.removeItem(item);
  }

  setSessionStorage(item: any, value: any): void {
    sessionStorage.setItem(item, value);
  }

  getSessionStorage(item: any): any {
    return sessionStorage.getItem(item);
  }

  getJsonSessionStorage(item: any) {
    return JSON.parse(this.getSessionStorage(item));
  }

  formatNumber(value: number, decimalPlaces: number = 2): string {
    if (value !== 0) {
      return value
        .toFixed(decimalPlaces) // Fija los decimales
        .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Agrega separadores de miles
    } else {
      return '0';
    }
  }

  alertSuccess(message: string) {
    Swal.fire({
      title: 'Éxito!',
      text: message,
      icon: 'success',
      confirmButtonColor: '#007F3C',
      confirmButtonText: 'Aceptar',
    });
  }

  alertWarnning(message: string) {
    Swal.fire({
      title: 'Alerta!',
      text: message,
      icon: 'warning',
      confirmButtonColor: '#007F3C',
      confirmButtonText: 'Aceptar',
    });
  }

  alertError(message: string) {
    Swal.fire({
      title: 'Error!',
      text: message,
      icon: 'error',
      confirmButtonColor: '#007F3C',
      confirmButtonText: 'Aceptar',
    });
  }

  alertWithQuestion(message: string, callback: any) {
    Swal.fire({
      title: 'Geobosques',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#007F3C',
      cancelButtonColor: '#212529',
      confirmButtonText: 'SÍ',
      cancelButtonText: 'NO',
    }).then((result) => {
      if (result.isConfirmed) {
        callback();
      }
    });
  }

  formatDateDDMMYYYY(value: string | Date | null | undefined): string {
    if (!value) {
      return ''; // Retorna vacío si es null, undefined o ''
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return ''; // Retorna vacío si la fecha es inválida
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  formatearFecha(fecha: string): string {
    if (!fecha || !/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return fecha; // Validación básica

    const [anio, mes, dia] = fecha.split('-');
    return `${dia}/${mes}/${anio}`;
  }

  extractDate(dateTimeStr: string): string {
    const date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses comienzan en 0
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  extractTime(dateTimeStr: string): string {
    const date = new Date(dateTimeStr);
    if (isNaN(date.getTime())) return '';
    return date.toTimeString().split(' ')[0]; // "HH:mm:ss"
  }
}
